import React, { useEffect, useState } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import { Grid, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomModal from "../Modals/CustomModal/CustomModal";
import CustomCancelButton from "../components/CustomSmallButtons/CustomCancelButton";
import CustomAcceptButton from "../components/CustomSmallButtons/CustomAcceptButton";



const MobileRedirect: React.FC = () => {
  const [showPopUp, setShowPopUp] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const { t } = useTranslation();
  const appScheme = 'com.cipherbizz.cbemployeeapp://open';
  const android = "https://play.google.com/store/apps/details?id=com.cipherbizz.cbemployeeapp";
  const ios = "https://apps.apple.com/in/app/cipherbizz/id6446880270";

  useEffect(() => {
    if (isMobile) {
      setShowPopUp(true);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePopUpClose = () => {
    setShowPopUp(false);
  };

  const handleOpenApp = () => {
        window.location.href = appScheme;

        setTimeout(() => {
            if (window.location.href === appScheme || document.visibilityState !== "hidden") {
                redirectToDownLoad();
            }
        }, 1000);
  };

  const redirectToDownLoad = () =>{
    if (isAndroid) {
      window.location.href = android;
    } else if (isIOS) {
      window.location.href = ios;
    } else {
      setShowPopUp(false)
    }
  }


  return (
    <CustomModal isModalOpen={showPopUp} modalWidth={isIOS ? "70vw" : "80vh"}>
      <Grid>
        <Grid item>
          <Box sx={{textAlign:'center',textWrap:'nowrap'}}>
          <Typography sx={{ fontSize: isIOS ? '1.3em' : '2.4em' }}>
              {t('Click the button to open app?')}
            </Typography>
          </Box>
          </Grid>
        <Grid sx={{display:"flex",justifyContent:'center',marginTop:'1em',textWrap:'nowrap'}}>
        <Box><CustomCancelButton padding={isIOS ? "" : "4em 1em"} fontSize={isIOS ? "" : "2em"}  onClickCancel={handlePopUpClose}  title="Cancel"/></Box>
        <Box ><CustomAcceptButton padding={isIOS ? "" : "4em 1em"} fontSize={isIOS ? "" : "2em"}  onClickSubmit={handleOpenApp} title="Open App"/></Box>
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default MobileRedirect;
